export const types = {
  ADD_PERSON: 'ADD_PERSON',
  REMOVE_PERSON: 'REMOVE_PERSON',
  GET_BY_ID: {
    STARTED: 'GET_BY_ID_STARTED',
    FAILURE: 'GET_BY_ID_FAILURE',
    SUCCESS: 'GET_BY_ID_SUCCESS',
  },
  GET_BY_LINKS_UUID: {
    STARTED: 'GET_BY_LINKS_UUID_STARTED',
    FAILURE: 'GET_BY_LINKS_UUID_FAILURE',
    SUCCESS: 'GET_BY_LINKS_UUID_SUCCESS',
  },
  RESET: 'RESET_CONFERENCE',
  GET_TRANSCRIPT_ENTRY_BY_ID: 'GET_TRANSCRIPT_ENTRY_BY_ID',
  ADD_TAG: 'ADD_TAG',
  DELETE_TAG: 'DELETE_TAG',
  SET: {
    FIELD: 'SET_FIELD',
    PERSON_FIELD: 'SET_PERSON_FIELD',
    CALL_AUDIO: 'SET_CALL_AUDIO',
    TITLE: 'SET_CONFERENCE_TITLE',
    LANGUAGE: 'TRSC_SET_LANGUAGE',
  },
  CREATE_CONFERENCE: {
    STARTED: 'CREATE_CONFERENCE_STARTED',
    FAILURE: 'CREATE_CONFERENCE_FAILURE',
    SUCCESS: 'CREATE_CONFERENCE_SUCCESS',
  },
  UPDATE_CONFERENCE: {
    STARTED: 'UPDATE_CONFERENCE_STARTED',
    FAILURE: 'UPDATE_CONFERENCE_FAILURE',
    SUCCESS: 'UPDATE_CONFERENCE_SUCCESS',
  },
  INSERT: {
    STARTED: 'INSERT_STARTED',
    FAILURE: 'INSERT_FAILURE',
    SUCCESS: 'INSERT_SUCCESS',
  },
  DOWNLOAD: {
    STARTED: 'DOWNLOAD_TRANSCRIPT_STARTED',
    FAILURE: 'DOWNLOAD_TRANSCRIPT_FAILURE',
    SUCCESS: 'DOWNLOAD_TRANSCRIPT_SUCCESS',
  },
  REGENERATE_PIN: {
    STARTED: 'REGENERATE_PIN_STARTED',
    FAILURE: 'REGENERATE_PIN_FAILURE',
    SUCCESS: 'REGENERATE_PIN_SUCCESS',
  },
  REQUEST_HUMAN_TRANSCRIPT: {
    STARTED: 'REQUEST_HUMAN_TRANSCRIPT_STARTED',
    FAILURE: 'REQUEST_HUMAN_TRANSCRIPT_FAILURE',
    SUCCESS: 'REQUEST_HUMAN_TRANSCRIPT_SUCCESS',
  },
};

export const fieldTypes = {
  TITLE: 'title',
  DATE: 'date',
  CREATE_TRANSCRIPT: 'isTranscriptNeeded',
  CREATE_AI_TRANSCRIPT: 'isAITranscriptNeeded',
  USE_TWO_FACTOR_AUTH: 'isTwoFactorAuthRequired',
  ANALYST: 'userId',
  INTRO_MESSAGE: 'introMessageId',
  CLIENT_REFERENCE: 'clientReference',
  PROJECT_CODE: 'projectCode',
  SPECIALIST_NUMBER: 'specialistNumber',
  ORGANIZATION: 'organizationId',
  CURRENT_ORGANIZATION: 'organization',
  EXPANDED_ID: 'expandedId',
  LANGUAGE: 'language',
};

export const personFieldTypes = {
  NAME: 'name',
  TYPE: 'type',
  PHONE_NUMBER: 'phoneNumber',
  COUNTRY: 'country',
  TIME_ZONE: 'timezone',
  EMAIL: 'email',
  CONFERENCE_PHONE_NUMBER_ID: 'conferencePhoneNumberId',
};

export const addPerson = () => ({
  type: types.ADD_PERSON,
});

export const removePerson = (id) => ({
  type: types.REMOVE_PERSON,
  id,
});

export const addTag = (tag) => ({
  type: types.ADD_TAG,
  tag,
});

export const deleteTag = (tag) => ({
  type: types.DELETE_TAG,
  tag,
});

export const setField = (field, value) => ({
  type: types.SET.FIELD,
  field,
  value,
});

export const setCallAudio = (file) => ({
  type: types.SET.CALL_AUDIO,
  file,
});

export const getConferenceById = (id, isAIRoute) => ({
  type: types.GET_BY_ID.STARTED,
  id,
  isAIRoute,
});

export const getTranscriptByLinksUUID = (uuid, isAIRoute) => ({
  type: types.GET_BY_LINKS_UUID.STARTED,
  uuid,
  isAIRoute,
});

export const getTranscriptByLinksUUIDSuccess = () => ({
  type: types.GET_BY_LINKS_UUID.SUCCESS,
});

export const setPersonField = (id, field, value) => ({
  type: types.SET.PERSON_FIELD,
  id,
  field,
  value,
});

export const createConference = (preview) => ({
  type: types.CREATE_CONFERENCE.STARTED,
  preview,
});

export const updateConference = (preview) => ({
  type: types.UPDATE_CONFERENCE.STARTED,
  preview,
});

export const createTranscript = (preview) => ({
  type: types.INSERT.STARTED,
  preview,
});

export const resetConference = () => ({
  type: types.RESET,
});

export const download = (filename, watermark) => ({
  type: types.DOWNLOAD.STARTED,
  filename,
  watermark,
});
export const downloadSuccess = () => ({ type: types.DOWNLOAD.SUCCESS });
export const downloadFailure = (errors) => ({
  type: types.DOWNLOAD.FAILURE,
  errors,
});

export const regeneratePin = () => ({
  type: types.REGENERATE_PIN.STARTED,
});

export const getTranscriptEntryById = (id, isAIRoute) => ({
  type: types.GET_TRANSCRIPT_ENTRY_BY_ID,
  id,
  isAIRoute,
});

export const requestHumanTranscript = (conferenceId) => ({
  type: types.REQUEST_HUMAN_TRANSCRIPT.STARTED,
  conferenceId,
  message: 'Started requesting transcript',
});

export const changeLanguage = ({ language, languagePrefs }) => ({
  type: types.SET.LANGUAGE,
  language,
  languagePrefs,
});



// WEBPACK FOOTER //
// ./redux/actions/conference.js